import React from "react";

const TargetSegments = () => {
  return <div>TargetSegments</div>;
};

export default TargetSegments;
